import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  DeleteLeadSubscriptionMutation,
  DeleteLeadSubscriptionMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { removeCompanyLeadSubscription } from "./leadSubscriptionCache";

const deleteLeadSubscriptionMutation = graphql(`
  mutation deleteLeadSubscription($id: String!) {
    deleteLeadSubscription(id: $id)
  }
`);

export function useDeleteLeadSubscription(
  options?: UseMutationOptions<
    DeleteLeadSubscriptionMutation,
    unknown,
    DeleteLeadSubscriptionMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(deleteLeadSubscriptionMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      removeCompanyLeadSubscription(queryClient, variables.id);
      options?.onSuccess && options?.onSuccess(data, variables, context);
    },
  });
  return { data: data?.deleteLeadSubscription, ...rest };
}
